import React from 'react';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { chatStyles } from '../styles';

interface ChatHeaderProps {
  showControls?: boolean;
  onMinimize?: () => void;
  onClose?: () => void;
  customStyles?: {
    header?: {
      bgcolor?: string;
    };
    avatar?: {
      bgcolor?: string;
    };
  };
  isExpanded?: boolean;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({
  showControls,
  onMinimize,
  onClose,
  customStyles,
  isExpanded,
}) => {
  return (
    <Box
      sx={{
        ...chatStyles.header,
        bgcolor: customStyles?.header?.bgcolor || '#3f4372',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          src={`${process.env.PUBLIC_URL}/images/passarinho-lia.svg`}
          alt="Lia"
          sx={{
            ...chatStyles.avatar,
            bgcolor: customStyles?.avatar?.bgcolor || '#00384d',
          }}
        />
        <Typography
          variant="h5"
          sx={{
            ...chatStyles.title,
            color: isExpanded ? '#28272C' : '#FDFDFD',
          }}
        >
          LIA
        </Typography>
      </Box>
      {showControls && (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <IconButton 
            onClick={onMinimize} 
            size="small" 
            sx={chatStyles.controlButton}
          >
            <Box 
              sx={{ 
                width: '12px',
                height: '2px',
                backgroundColor: '#28272C',
                borderRadius: '1px'
              }} 
            />
          </IconButton>
          <IconButton 
            onClick={onClose} 
            size="small" 
            sx={chatStyles.controlButton}
          >
            <CloseIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
}; 